import React from "react"
import { makeStyles } from "@material-ui/core/styles"
import ParticipantProgress from "./ParticipantProgress"

const useStyle = makeStyles((theme) => ({
    participantGrid: {
        [theme.breakpoints.up("md")]: {
            display: "grid",
            gridTemplateColumns: "repeat(auto-fill,minmax(85px,1fr))",
            gridAutoRows: "min-content",
            gridGap: theme.spacing(3),
        },
    },
}))

const ParticipantDetailProgressDetail = (props) => {
    const { participantHaveRolesGroupedByRole } = props
    const classes = useStyle()
    return (
        <div className="sparca-roles-list-contents">
            <section className={classes.participantGrid}>
                {participantHaveRolesGroupedByRole &&
                    participantHaveRolesGroupedByRole.map((participant) => (
                        <ParticipantProgress key={participant.participantId} participant={participant} />
                    ))}
            </section>
        </div>
    )
}

export default ParticipantDetailProgressDetail
